import React, { useCallback } from 'react';
import Slider from '@mui/material/Slider';
import { FieldsetGroup } from '@/components';

interface ShoreSliderProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}

const SHORE_MARKS = [
  { value: 45, label: '45' },
  { value: 50, label: '50' },
  { value: 55, label: '55' },
  { value: 60, label: '60' },
  { value: 65, label: '65' },
];

/**
 * ShoreSlider — MUI Slider (45–65, step=5) inside a fieldset
 * with "Shore A (ShA)" legend.
 *
 * Mirrors the original Python Shore slider on the input panel.
 */
const ShoreSlider: React.FC<ShoreSliderProps> = ({
  value,
  onChange,
  min = 45,
  max = 65,
  step = 5,
}) => {
  const handleChange = useCallback(
    (_e: Event, v: number | number[]) => {
      onChange(typeof v === 'number' ? v : v[0]);
    },
    [onChange],
  );

  return (
    <FieldsetGroup legend="Shore A (ShA)">
      <Slider 
        sx={{
          width: '95%',
          mx: 'auto',
          display: 'flex',

          // Mark labels (45, 50, 55...)
          '& .MuiSlider-markLabel': {
            fontSize: '0.75rem', 
          },

          // Value label (tooltip when sliding)
          '& .MuiSlider-valueLabel': {
            fontSize: '0.9rem',
            backgroundColor: '#1976d2', // tooltip background
            color: '#fff',              // text color
          },
        }}
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
        marks={SHORE_MARKS}
        valueLabelDisplay="auto"
        size="small"
        color="info"
        aria-label="Shore A hardness"
      />
    </FieldsetGroup>
  );
};

export default React.memo(ShoreSlider);
